var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUespMss(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 158,
    viewBox: "0 0 158 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6454_180155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.9999 158C122.63 158 158 122.63 158 78.9999C158 35.3694 122.63 0 78.9999 0C35.3694 0 0 35.3694 0 78.9999C0 122.63 35.3694 158 78.9999 158Z",
    fill: "#217AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.996 78.9998C157.996 78.2215 157.982 77.4469 157.959 76.6742L130.531 49.2461L78.996 19.4922L27.4609 49.2461V108.754L76.6704 157.963C77.4432 157.986 78.218 158 78.996 158C122.627 158 157.996 122.63 157.996 78.9998Z",
    fill: "#0D5DD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.531 108.754L78.996 138.507L27.4609 108.754V49.2461L78.996 19.4922L130.531 49.2461V108.754Z",
    fill: "#00D4D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.535 49.2458V108.754L79 138.508V19.4916L130.535 49.2458Z",
    fill: "#009CA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4609 49.2463L78.996 79V138.508L27.4609 108.754V49.2463Z",
    fill: "#FEE572"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.535 49.2463L79 79V138.508L130.535 108.754V49.2463Z",
    fill: "#0A2A58"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6454_180155"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 158,
    height: 158,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUespMss);
export default __webpack_public_path__ + "static/media/UESP_MSS.ed3a4273a3b10cf1a021d3d78e410370.svg";
export { ForwardRef as ReactComponent };